// extracted by mini-css-extract-plugin
export default {"button":"Np-z","reviewSort":"Op-z"};